import React, { useEffect, useState } from "react";
import UserBillingItem from "./UserBillingItem";
import { doRequest } from "../utils/helper";
import { useParams } from "react-router-dom";

export default function UserBillingHistory({ planDetails }) {
  const [userInsights, setUserInsights] = useState({
    totalAmount: 0,
    totalVariations: 0
  });
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const getUserInsights = async () => {
    try {
      setLoading(true);
      const response = await doRequest(
        "",
        "GET",
        `user/user-detaild-insights?userId=${id}`
      );
      
      if (response?.resultFlag === 1) {
        setUserInsights({
          totalAmount: response?.response?.data?.totalAmmount || 0,
          totalVariations: response?.response?.data?.totalVeriations || 0
        });
      } else {
        console.error("Failed to fetch user insights:", response?.message);
      }
    } catch (error) {
      console.error("Error fetching user insights:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getUserInsights();
    }
  }, [id]);
  return (
    <>
      <div
        id="main-container"
        className="container-fluid main"
        // style={{ overflowY: "scroll" }}
      >
        <section className="home">
          {/* <div className="container-fluid"> */}
            <div>
              <div className="row_bill_pad">
                <div className="row row_billing">
                  <div className="col-sm-3">
                    <h6 className="history_header">Total History</h6>
                  </div>
                  <div className="col-sm-4">
                    <h6 className="var_total">Total Amount</h6>
                    <h4 className="var_amount">
                      <sup>₹</sup>
                      <span>{loading ? "..." : userInsights.totalAmount}</span>
                    </h4>
                  </div>
                  <div className="col-sm-4">
                    <h6 className="var_total">Total Variations</h6>
                    <h4 className="var_amount">
                      <span>{loading ? "..." : userInsights.totalVariations}</span>
                    </h4>
                  </div>
                </div>

                <div className="">
                  <ul className="plan_billheader">
                    <li className="planbill_wid">
                      <h6>Plan</h6>
                    </li>

                    <li className="am_wid">
                      <h6>Amount</h6>
                    </li>

                    <li className="var_wid">
                      <h6>Variation Created</h6>
                    </li>

                    <li className="start_wid">
                      <h6>Start Date</h6>
                    </li>

                    <li className="end_wid">
                      <h6>End Date</h6>
                    </li>

                    <li className="stat_wid">
                      <h6>Status</h6>
                    </li>

                    <li className="dwnin_wid">
                      <h6 className="amt_right">Amount</h6>
                    </li>
                  </ul>

                  <UserBillingItem planDetails={planDetails} />
                </div>
              </div>
            </div>
          {/* </div> */}
        </section>
      </div>
    </>
  );
}
